import * as React from 'react';
import TimeAgo from 'timeago-react';
import { AnimatePresence, motion } from "framer-motion";
import data from '@emoji-mart/data';
import { Picker } from 'emoji-mart';
import { useDropzone } from 'react-dropzone';

import myProfilePhoto from '../../../assets/images/my_profile.png';

import useClickOutside from '../../../Hooks/useClickOutside';
import { useRef, useState, useEffect } from 'react';
import WebCamCapture from './WebCam/WebCam';
import './Posts.scss';
import { GIFs } from './GIFs/GIFs';
import { VoiceRecorder } from './VoiceRecorder/VoiceRecorder';
import { PostGrid } from '../../../Components/PostGrid/PostGrid';
import { PreviewCarousel } from '../../../Components/PreviewCarousel/PreviewCarousel';
import { AudioPlayer } from '../../../Components/AudioPlayer/AudioPlayer';
import { NavLink } from 'react-router-dom';
import { allFollowersPeoplesData } from '../../../Shared/GlobalDataFactory';
import { EditPost } from './EditPost/EditPost';
import { GlobalUncContext } from '../../../Components/Layout/Layout';

export interface IPostsProps {


}

export function Posts(props: IPostsProps) {
    const { setPostDatas, postDatas, } = React.useContext(GlobalUncContext)


    const [showEditModal, setShowEditModal] = useState({ isOpen: false, postID: -1 });
    const editModalRef = useRef(null);
    useClickOutside(editModalRef, () => setShowEditModal({ isOpen: false, postID: -1 }));








    const [commentsShow, setCommentsShow] = React.useState({
        isOpen: false,
        index: 0,
    })

    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle Photo Upload----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const [clickedPhUpIndex, setClickedPhUpIndex] = useState(-1)
    const [uploadedFile, setUploadedFile] = useState<any>(null);
    const { getRootProps, getInputProps, fileRejections, acceptedFiles } = useDropzone({
        accept: 'image/*',
        maxFiles: 1,
        multiple: false,
        maxSize: 100000000,
        onDrop: acceptedFiles => {
            const acceptedFileWithPreviewSrc = acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }))
            setUploadedFile(acceptedFileWithPreviewSrc[0]);

        }
    });

    useEffect(() => {
        const assetsPreviewUnderComment = document.getElementById(`assetsPreviewUnderComment${clickedPhUpIndex}`) as HTMLDivElement;
        if (uploadedFile) {
            assetsPreviewUnderComment.innerHTML = '';
            const img = document.createElement('img')
            img.setAttribute('class', 'w-9 h-auto sm:w-24 sm:h-auto mr-2 mb-3 rounded-lg border border-cusBlueWhite')
            img.setAttribute('src', `${uploadedFile.preview}`)
            assetsPreviewUnderComment?.appendChild(img)
        }
    }, [clickedPhUpIndex, uploadedFile])





    const autoIncraseHeight = (e: any) => {
        e.target.style.height = "1px";
        e.target.style.height = (e.target.scrollHeight) + "px";
    }
    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----Hanlde send comment and comment show----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const comments_box = document.getElementById(`comments_box_${commentsShow.index}`)
    React.useEffect(() => {
        comments_box?.classList.contains("hidden")
            ? comments_box?.classList.replace('hidden', "block")
            : comments_box?.classList.replace("block", 'hidden')
    }, [commentsShow.isOpen])

    React.useEffect(() => {
        comments_box?.scrollTo(0, comments_box.scrollHeight);
    }, [postDatas, commentsShow.isOpen,])


    // Comment Send and Open the comment box---------------------------
    const [getSubmitCommentInfo, setGetSubmitCommentInfo] = React.useState({
        scroll: false,
        id: 0,
    })



    const [isCommentSubmitCommand, setIsCommentSubmitCommand] = useState(false)
    const handleCommentKeyboardEvent = (e: any) => {
        if (e.keyCode === 13) {
            setIsCommentSubmitCommand(true)
            if (e.shiftKey) {
                setIsCommentSubmitCommand(false)
            }
        }
        else {
            setIsCommentSubmitCommand(false)
        }
    }

    // Send comment-----------------------
    const handleCommentSubmit = (e: any, index: number, postId: number) => {
        const assetsPreviewUnderComment = document.getElementById(`assetsPreviewUnderComment${index}`) as HTMLDivElement;
        // const commentWriteBox: any = (document.getElementById(`commentWriteBox${index}`) as HTMLDivElement);
        const commentIconsBox = document.getElementById(`commentIconsBox${index}`);
        const previousPostData = [...postDatas]
        autoIncraseHeight(e)

        let todayDate = new Date().toLocaleString('en-US', { hour12: false }).split(', ');
        const dateAr = todayDate[0].split('/').reverse()
        const date = `${dateAr[0]}-${('0' + JSON.parse(dateAr[2])).slice(-2)}-${('0' + JSON.parse(dateAr[1])).slice(-2)}`;
        const time = todayDate[1].split(" ")[0]
        const todayDateAndTime = date + ' ' + time;


        if (e.target.value.length > 0 && e.target.value.replace(/\s/g, "").length) {
            commentIconsBox?.classList.replace('absolute', 'static')

            if (isCommentSubmitCommand) {
                const findMatchPost = previousPostData.find(data => data.id === postId)
                const newComment = {
                    id: findMatchPost!.comments.length + 1,
                    profLogo: myProfilePhoto,
                    commTitle: e.target.value,
                    commPhoto: uploadedFile?.preview,
                    time: todayDateAndTime,
                }
                findMatchPost?.comments.push(newComment)
                setPostDatas(previousPostData)
                setGetSubmitCommentInfo({ scroll: !getSubmitCommentInfo.scroll, id: index })
                e.target.value = '';
                e.target.style.height = "24px";
                commentIconsBox?.classList.replace('static', 'absolute')

                if (uploadedFile && clickedPhUpIndex >= 0) {
                    assetsPreviewUnderComment.innerHTML = '';
                    setClickedPhUpIndex(-1)
                    setUploadedFile(null)
                }
            } else {
                return
            }
        }
        else {
            commentIconsBox?.classList.replace('static', 'absolute')
            e.target.value = '';
            e.target.style.height = "24px";
        }
    }
    React.useEffect(() => {
        const comments__box = document.getElementById(`comments_box_${getSubmitCommentInfo.id}`)
        comments__box?.classList.replace('hidden', "block")
        comments__box?.scrollTo(0, comments__box.scrollHeight);
    }, [getSubmitCommentInfo])







    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----Hanlde Emoji picker----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const emojiPikcerRefs = useRef(new Array())
    const [clickedPickerIndex, setClickedPickerIndex] = useState(-1)
    const [isPickerOpen, setIsPickerOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: emojiPikcerRefs.current[clickedPickerIndex] }, () => {
        const newVisibilities = [...isPickerOpen];
        newVisibilities[clickedPickerIndex] = false;
        setIsPickerOpen(newVisibilities);
    })

    const hanldeEmojiOpenBtn = (index: any) => {
        const newVisibilities = [...isPickerOpen];
        newVisibilities[index] = !newVisibilities[index];

        setIsPickerOpen(newVisibilities);
        setClickedPickerIndex(index)
    };

    useEffect(() => {
        const arrayData = emojiPikcerRefs.current.map((data, index) => `${index}`)
        setIsPickerOpen(() => arrayData.map((x) => false));
    }, [])


    // Set Emoji from Emoji to comment box-----------
    const hanldeEmojiSetOnComment = (e: any, id: any) => {
        const commentWriteBox: any = (document.getElementById(`commentWriteBox${clickedPickerIndex}`) as HTMLDivElement);
        const writeBoxCursorIndex = commentWriteBox.value.slice(0, commentWriteBox.selectionStart).length
        // let hex: any = e.native?.codePointAt(0)?.toString(16)
        // let emo = String.fromCodePoint(hex);
        const myOutput = commentWriteBox.value.slice(0, writeBoxCursorIndex) + e.native + commentWriteBox.value.slice(writeBoxCursorIndex, commentWriteBox.value.length)
        commentWriteBox.value = myOutput;

        commentWriteBox.selectionEnd = commentWriteBox.selectionStart = writeBoxCursorIndex + e.native.length;
        commentWriteBox.focus();
    }

    // Show Emoji Picker----------------------
    const pickerRef = React.useRef(null)
    const hanldeMyEmojiPicker = (props: any) => {
        return (
            new Picker({
                ...props, data, ref: pickerRef, emojiButtonRadius: '60px',
                // set: 'apple',
                // theme: localStorage.theme ? "dark" : "light",
                previewPosition: 'none',
                emojiButtonColors: [
                    'rgba(155,223,88,.7)',
                    'rgba(149,211,254,.7)',
                    'rgba(247,233,34,.7)',
                    'rgba(238,166,252,.7)',
                    'rgba(255,213,143,.7)',
                    'rgba(211,209,255,.7)',
                ],
            })
        )
    }
    useEffect(() => {
        let emojiPicker: any = document.getElementById(`emojiPicker${clickedPickerIndex}`)
        if (emojiPicker) {
            if (isPickerOpen.length > 0 && isPickerOpen[clickedPickerIndex]) {
                const newEl = hanldeMyEmojiPicker({ onEmojiSelect: (e: any) => hanldeEmojiSetOnComment(e, clickedPickerIndex) })
                emojiPicker.appendChild(newEl)
            }
            else {
                emojiPicker.innerHTML = '';
                setClickedPickerIndex(-1)
            }
        }
    }, [isPickerOpen])









    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle WebCam----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const [isWebcamOpen, setIsWebcamOpen] = useState({ isOpen: false, index: -1, postId: -1 })
    const [webCamImage, setWebCamImage] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false)

    const webCamModalRef = React.useRef(null)
    useClickOutside(webCamModalRef, () => setIsWebcamOpen({ isOpen: false, index: -1, postId: -1 }))


    const [uploadingPercentage, setUploadingPercentage] = useState(0)
    const hanldeWebCamPhotoSubmit = (src: any) => {
        // In future if need this function then we will use it
        // const assetsPreviewUnderComment = document.getElementById(`assetsPreviewUnderComment${isWebcamOpen.index}`)
        // setIsSubmitted(true)
        // setWebCamImage(src)

        // for (let i = 0; i <= 100; i++) {
        //     setTimeout(() => {
        //         setUploadingPercentage(i)
        //     }, 400)
        // }

        // setTimeout((e) => {
        //     assetsPreviewUnderComment!.innerHTML = '';
        //     const img = document.createElement('img')
        //     img.setAttribute('class', 'xs:w-9 h-9 sm:w-14 sm:h-14 mr-2 mb-2 border-2 border-cusBlueWhite shadow-md rounded-lg')
        //     img.setAttribute('src', `${src}`)
        //     assetsPreviewUnderComment?.appendChild(img)

        //     setIsSubmitted(false)
        //     setIsWebcamOpen({ isOpen: false, index: -1 })
        //     setUploadingPercentage(0)
        // }, 1500)

        const assetsPreviewUnderComment = document.getElementById(`assetsPreviewUnderComment${isWebcamOpen.index}`)
        setIsSubmitted(true)
        setWebCamImage(src)


        setTimeout(() => {
            setUploadingPercentage(100)
        }, 400)


        setTimeout(() => {
            const previousPostData = [...postDatas]
            let todayDate = new Date().toLocaleString('en-US', { hour12: false }).split(', ');
            const dateAr = todayDate[0].split('/').reverse()
            const date = `${dateAr[0]}-${('0' + JSON.parse(dateAr[2])).slice(-2)}-${('0' + JSON.parse(dateAr[1])).slice(-2)}`;
            const time = todayDate[1].split(" ")[0]
            const todayDateAndTime = date + ' ' + time;

            const findMatchPost = previousPostData.find(data => data.id === isWebcamOpen.postId)
            const newComment = {
                id: findMatchPost!.comments.length + 1,
                profLogo: myProfilePhoto,
                commPhoto: src,
                time: todayDateAndTime,
            }
            findMatchPost?.comments.push(newComment)
            setPostDatas(previousPostData)
            setGetSubmitCommentInfo({ scroll: !getSubmitCommentInfo.scroll, id: isWebcamOpen.index })


            setIsSubmitted(false)
            setIsWebcamOpen({ isOpen: false, index: -1, postId: -1 })
            setUploadingPercentage(0)
        }, 1500)

    }

    useEffect(() => {
        isWebcamOpen.isOpen && setWebCamImage({})
    }, [isWebcamOpen])







    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle GIFs----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const gifBoxsRefs = useRef(new Array())
    const [clickedGIFBoxIndex, setClickedGIFBoxIndex] = useState({ index: -1, postId: -1, })
    const [isGIFBoxOpen, setIsGIFBoxOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: gifBoxsRefs.current[clickedGIFBoxIndex.index] }, () => {
        const newVisibilities = [...isGIFBoxOpen];
        newVisibilities[clickedGIFBoxIndex.index] = false;
        setIsGIFBoxOpen(newVisibilities);
    })
    const hanldeGIFBoxOpenBtn = (index: any, postId: number) => {
        const newVisibilities = [...isGIFBoxOpen];
        newVisibilities[index] = !newVisibilities[index];

        setIsGIFBoxOpen(newVisibilities);
        setClickedGIFBoxIndex({ index: index, postId: postId, })
    };


    useEffect(() => {
        const gigBox = document.getElementById(`gifBox${clickedGIFBoxIndex.index}`)

        if (gifBoxsRefs.current.length > 0 && isGIFBoxOpen[clickedGIFBoxIndex.index]) {
            gigBox?.classList.replace('hidden', 'absolute')
        }
        else {
            gigBox?.classList.replace('absolute', 'hidden')
            setClickedGIFBoxIndex({ index: -1, postId: -1, })
        }
    }, [isGIFBoxOpen])

    useEffect(() => {
        const arrayData = gifBoxsRefs.current.map((data, index) => `${index}`)
        setIsGIFBoxOpen(() => arrayData.map((x) => false));
    }, [])


    const handleGifOnClick = (data: any) => {
        const previousPostData = [...postDatas]
        let todayDate = new Date().toLocaleString('en-US', { hour12: false }).split(', ');
        const dateAr = todayDate[0].split('/').reverse()
        const date = `${dateAr[0]}-${('0' + JSON.parse(dateAr[2])).slice(-2)}-${('0' + JSON.parse(dateAr[1])).slice(-2)}`;
        const time = todayDate[1].split(" ")[0]
        const todayDateAndTime = date + ' ' + time;

        const findMatchPost = previousPostData.find(data => data.id === clickedGIFBoxIndex.postId)
        const newComment = {
            id: findMatchPost!.comments.length + 1,
            profLogo: myProfilePhoto,
            commPhoto: data.images.preview_gif.url,
            time: todayDateAndTime,
        }
        findMatchPost?.comments.push(newComment)
        setPostDatas(previousPostData)
        setGetSubmitCommentInfo({ scroll: !getSubmitCommentInfo.scroll, id: clickedGIFBoxIndex.index })

    }







    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle Voice Record----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const [isRecorderOpen, setIsRecorderOpen] = useState({ isOpen: false, index: -1, postId: -1 })
    // const [recordedData, setRecordedData] = useState({});
    // const [isRecorderSubmited, setIsRecorderSubmited] = useState(false)

    const recorderModalRef = React.useRef(null)
    useClickOutside(recorderModalRef, () => setIsRecorderOpen({ isOpen: false, index: -1, postId: -1 }))


    const hanldeVoiceSubmit = (voiceData: any) => {
        const previousPostData = [...postDatas]
        let todayDate = new Date().toLocaleString('en-US', { hour12: false }).split(', ');
        const dateAr = todayDate[0].split('/').reverse()
        const date = `${dateAr[0]}-${('0' + JSON.parse(dateAr[2])).slice(-2)}-${('0' + JSON.parse(dateAr[1])).slice(-2)}`;
        const time = todayDate[1].split(" ")[0]
        const todayDateAndTime = date + ' ' + time;

        const findMatchPost = previousPostData.find(data => data.id === isRecorderOpen.postId)
        const newComment = {
            id: findMatchPost!.comments.length + 1,
            profLogo: myProfilePhoto,
            commAudio: voiceData.url,
            time: todayDateAndTime,
        }
        findMatchPost?.comments.push(newComment)
        setPostDatas(previousPostData)
        setGetSubmitCommentInfo({ scroll: !getSubmitCommentInfo.scroll, id: isRecorderOpen.index })
        setIsRecorderOpen({ isOpen: false, index: -1, postId: -1 })
    }








    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----handle Loves----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const handleLoveBtnClick = (postId: number) => {
        const previousPostData = [...postDatas]
        const findMatchPost = previousPostData.find(data => data.id === postId)

        if (findMatchPost.isMyloves) {
            findMatchPost!.loves = findMatchPost!.loves - 1
            findMatchPost.isMyloves = false;
            setPostDatas(previousPostData)
        }
        else {
            findMatchPost!.loves = findMatchPost!.loves + 1
            findMatchPost.isMyloves = true;
            setPostDatas(previousPostData)
        }
    }





    // ミミ◦❧◦°˚°◦.¸¸◦°´❤*•.¸♥෴❤️෴ -----Share Functionality----- ෴❤️෴♥¸.•*❤´°◦¸¸.◦°˚°◦☙◦彡彡
    const [shareModalOpen, setShareModalOpen] = React.useState(false)
    const shareModalRef = React.useRef(null)
    useClickOutside(shareModalRef, () => setShareModalOpen(false))

    const [modalPeoplesData, setModalPeoplesData] = useState(allFollowersPeoplesData)

    const handleShareModalSearch = (e: any) => {
        const prevModalPeopleData = [...allFollowersPeoplesData]
        const findMatchPeoples = prevModalPeopleData.filter(data => data.name.toLowerCase().includes(e.target.value.toLowerCase()))

        setModalPeoplesData(findMatchPeoples);
    }






    // three dot modal
    const threeDotModalRefs = useRef(new Array())
    const [clickedThreeDotIndex, setClickedThreeDotIndex] = useState(-1)
    const [isThreeDotModalOpen, setIsThreeDotModalOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: threeDotModalRefs.current[clickedThreeDotIndex] }, () => {
        const newVisibilities = [...isThreeDotModalOpen];
        newVisibilities[clickedThreeDotIndex] = false;
        setIsThreeDotModalOpen(newVisibilities);
    })
    const hanldeThreeDotBtn = (index: any) => {
        const newVisibilities = [...isThreeDotModalOpen];
        newVisibilities[index] = !newVisibilities[index];

        setIsThreeDotModalOpen(newVisibilities);
        setClickedThreeDotIndex(index)
    };
    useEffect(() => {
        const arrayData = threeDotModalRefs.current.map((data, index) => `${index}`)
        setIsThreeDotModalOpen(() => arrayData.map((x) => false));
    }, [])



    // ---------------------Report Modal---------------------
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const reportModalRef = useRef(null);
    useClickOutside(reportModalRef, () => setReportModalOpen(false));

    const [reasonDropOpen, setReasonDropOpen] = React.useState(false)
    const [reasonText, setReasonText] = React.useState('Select a reason');
    let reasonDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(reasonDropRef, () => setReasonDropOpen(false))






    // handle post text see more and see less
    const allTitleBoxRefs = useRef(new Array())
    const [seeMoreShow, setSeeMoreShow] = React.useState(() => [].map((x) => false));

    const hanldeShowMoreLessBtn = (index: any) => {
        const newVisibilities = [...seeMoreShow];
        newVisibilities[index] = !newVisibilities[index];

        setSeeMoreShow(newVisibilities);
    };

    useEffect(() => {
        const arrayData = allTitleBoxRefs.current.map((data, index) => `${index}`)
        setSeeMoreShow(() => arrayData.map((x) => false));
    }, [])






    const [windowWidth, setWindowWidth] = useState(1920)
    useEffect(() => {
        setWindowWidth(window.outerWidth);
    }, [])


    const [carouselDataWithOpen, setCarouselDataWithOpen] = useState({
        isOpen: false,
        image: null,
        rootData: null,
    })

    const getImageData = (clickedImageSource?: any, clickedRootData?: any) => {
        setCarouselDataWithOpen({
            isOpen: true,
            image: clickedImageSource,
            rootData: clickedRootData,
        })
    }

    const getPostGridPorps = (images: any, rootData: any) => {
        let heightNumber = [260, 220]

        if (images.length >= 5) {
            heightNumber = windowWidth > 640 ? [300, 240] : [140, 110]
        }
        else if (images.length === 1) {
            heightNumber = windowWidth > 640 ? [348] : [170]
        }
        else if (images.length === 2) {
            heightNumber = windowWidth > 640 ? [360] : [170]
        }
        else if (images.length === 3) {
            heightNumber = windowWidth > 640 ? [340, 240] : [230, 110]
        }
        else if (images.length === 4) {
            heightNumber = windowWidth > 640 ? [290, 290] : [150, 150]
        }

        return {
            itemsLength: images.length,
            getDataByOnClick: getImageData,
            rootData: rootData,
            gapX: 0,
            gapY: 0,
            heights: heightNumber,
            images: images,
        };
    }






    // comment audio
    const setAudioPlayer = (src: any) => {
        const plyrProps: any = {
            source: {
                type: 'audio',
                title: 'Example title',
                sources: [
                    {
                        src: src,
                        type: 'audio/mp3',
                        size: 720,
                        provider: 'html5',

                    },
                ],
            },
            options: {
                enabled: true,
                debug: false,
                loadSprite: true,
                tooltips: { controls: false, seek: true },

            },
        }

        return (
            plyrProps
        )
    }

    const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
    const abbreviateNumber = (number: any) => {
        const tier = Math.log10(Math.abs(number)) / 3 | 0;
        if (tier === 0) return number;
        const suffix = SI_SYMBOL[tier];
        const scale = Math.pow(10, tier * 3);
        const scaled = number / scale;
        return scaled.toFixed(1) + suffix;
    }








    return (
        <div className="posts_main_box">
            {carouselDataWithOpen.isOpen &&
                <PreviewCarousel
                    setCarouselDataWithOpen={setCarouselDataWithOpen}
                    image={carouselDataWithOpen.image}
                    rootData={carouselDataWithOpen.rootData} />
            }

            {postDatas.map((postData: any, index: number) =>
                <motion.div
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.3 }}
                    key={postData.id} className="connect_single_post lightBlueBg w-full rounded-2xl mt-7">
                    <div className="flex justify-between items-center xs:p-2.5 sm:p-4 relative">
                        <div className="flex justify-start items-center">
                            <NavLink to="/publicProfile/activity">
                                <motion.div
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.99 }}
                                    transition={{ duration: 0.2 }}
                                    className="post_profile_pic rounded-full flex justify-center items-center
                            w-[32px] h-[32px] bg-[#9757F0]
                            sm:w-[46px] sm:h-[46px]
                            ">
                                    <div className="rounded-full
                                w-[28px] h-[28px] border-2 border-[#ffffff]
                                dark:border-[#1D1B4B]
                                sm:w-[42px] sm:h-[42px]
                                ">
                                        <img src={postData.postProfilePhoto} alt="" className="w-full h-full" />
                                    </div>
                                </motion.div>
                            </NavLink>
                            <div className="xs:ml-2 sm:ml-3 text-left">
                                <NavLink to="/publicProfile/activity">
                                    <h4 className="xs:text-xs sm:text-base font-bold dark:font-medium text-cusBlack dark:text-white">{postData.name}</h4>
                                </NavLink>
                                <div className="flex justify-start items-center">
                                    {/* <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusGray mr-4">{postData.minsAgo} mins</p> */}
                                    <TimeAgo
                                        className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusGray mr-4"
                                        datetime={postData.minsAgo}
                                        locale='en_US'
                                    />
                                    <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-2 sm:w-auto grayToBlackSVG" width="11.78" height="11.071" viewBox="0 0 11.78 11.071">
                                        <path id="Combined_Shape" data-name="Combined Shape" d="M0,11.071V8.348a3.652,3.652,0,0,1,7.3-.035.155.155,0,0,1,0,.035c0,.1,0,2.722,0,2.722Zm8.062-.463V8.584a3.373,3.373,0,0,0-.975-2.6c-.033-.024-.132-.113-.132-.113s.081-.059.132-.089A4.9,4.9,0,0,1,8.84,5.348a3.067,3.067,0,0,1,2.939,3.1c0,.01,0,2.158,0,2.158Zm-1.3-7.7a2,2,0,1,1,2,2A2,2,0,0,1,6.761,2.9ZM1.444,2.21A2.209,2.209,0,1,1,3.652,4.418,2.211,2.211,0,0,1,1.444,2.21Z" fill="rgba(255,255,255,0.53)" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <button className="mr-1 relative w-7 h-7 md:w-10 md:h-10 rounded-full flex justify-center items-center"
                            onClick={() => hanldeThreeDotBtn(index)}
                            ref={(el) => threeDotModalRefs.current[index] = el}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="xs:h-4 sm:h-auto" width={5} height={21} viewBox="0 0 5 21">
                                <g id="Group_1382" data-name="Group 1382" transform="translate(-724 -1425)">
                                    <circle id="Ellipse_374" data-name="Ellipse 374" cx="2.5" cy="2.5" r="2.5" transform="translate(724 1425)" fill="#6f6dab" />
                                    <circle id="Ellipse_375" data-name="Ellipse 375" cx="2.5" cy="2.5" r="2.5" transform="translate(724 1433)" fill="#6f6dab" />
                                    <circle id="Ellipse_376" data-name="Ellipse 376" cx="2.5" cy="2.5" r="2.5" transform="translate(724 1441)" fill="#6f6dab" />
                                </g>
                            </svg>

                            <div className="absolute right-3 top-6 md:top-9 z-40 overflow-hidden bg-white shadow-xl dark:bg-[#292757] rounded">
                                <AnimatePresence>
                                    {isThreeDotModalOpen[index] &&
                                        <motion.div
                                            initial={{ height: 0, width: 0 }}
                                            animate={{ height: "auto", width: '176px' }}
                                            exit={{ height: 0, width: 0 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            {postData.isMyPost
                                                ? <div>
                                                    <div className="w-full py-2 cursor-pointer hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 text-left"
                                                        onClick={() => setShowEditModal({ isOpen: !showEditModal.isOpen, postID: postData.id })}>
                                                        <p className="text-l-LightBlack dark:text-white text-xs sm:text-sm md:text-lg font-black ml-2">Edit</p>
                                                    </div>
                                                    <div className="w-full py-2 cursor-pointer hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 text-left">
                                                        <p className="text-l-LightBlack dark:text-white text-xs sm:text-sm md:text-lg font-black ml-2">Delete</p>
                                                    </div>
                                                    <div className="w-full py-2 cursor-pointer hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 text-left">
                                                        <p className="text-l-LightBlack dark:text-white text-xs sm:text-sm md:text-lg font-black ml-2">Hide</p>
                                                    </div>
                                                </div>

                                                : <div>
                                                    <div className="w-full py-2 cursor-pointer hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 text-left"
                                                        onClick={() => setReportModalOpen(!reportModalOpen)}>
                                                        <p className="text-l-LightBlack dark:text-white text-xs sm:text-sm md:text-lg font-black ml-2">Report</p>
                                                    </div>
                                                    <div className="w-full py-2 cursor-pointer hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 text-left">
                                                        <p className="text-l-LightBlack dark:text-white text-xs sm:text-sm md:text-lg font-black ml-2">Hide</p>
                                                    </div>
                                                </div>
                                            }
                                        </motion.div>

                                    }
                                </AnimatePresence>
                            </div>
                        </button>
                    </div>


                    <p className={`xs:text-xs sm:text-base xs:mb-3 sm:my-4 font-normal dark:font-thin text-cusBlack dark:text-white text-left ml-2 break-all pr-3`}
                        style={{ whiteSpace: 'pre-line' }}
                        ref={(el) => allTitleBoxRefs.current[index] = el}
                    >
                        {postData.postText.split("\n").length > 4
                            ? <span>
                                {seeMoreShow[index]
                                    ? postData.postText
                                    : <span>
                                        {postData.postText.split("\n")[0]}<br />
                                        {postData.postText.split("\n")[1]}<br />
                                        {postData.postText.split("\n")[2]}<br />
                                        {postData.postText.split("\n")[3]}
                                    </span>}

                                <button className="inline-block text-cusBlack font-bold dark:text-cusBlueWhite ml-2"
                                    onClick={() => hanldeShowMoreLessBtn(index)}
                                >
                                    {seeMoreShow[index] ? "...See less" : "See more..."}
                                </button>
                            </span>


                            : postData.postText.length > 200
                                ? <span>
                                    {seeMoreShow[index]
                                        ? postData.postText.slice(0, postData.postText.length)
                                        : postData.postText.slice(0, 200)}

                                    <button className="inline-block text-cusBlack font-bold dark:text-cusBlueWhite ml-2"
                                        onClick={() => hanldeShowMoreLessBtn(index)}
                                    >
                                        {seeMoreShow[index] ? "...See less" : "See more..."}
                                    </button>
                                </span>
                                : postData.postText
                        }
                    </p>



                    {postData.postImages.length > 0 &&
                        <div className="" >
                            <PostGrid propObject={getPostGridPorps(postData.postImages, postData.postImages)} />
                        </div>
                    }

                    {postData.postType &&
                        <div className="px-4 py-3 mb-2 bg-[#efefef] dark:bg-[#363375] flex justify-between items-center overflow-hidden">
                            <div className="flex-1 flex flex-col mr-3">
                                <p className="text-l-LightBlack dark:text-cusBlueWhite font-bold text-xxs xsm:text-xs sm:text-sm lg:text-base
                            w-full break-all">30% Discount</p>
                                <p className="text-l-LightBlack dark:text-cusBlueWhite text-3xs xsm:text-xs lg:text-sm
                            w-full break-all">95% Support, 55% uptime, ETH, MDN payment</p>
                            </div>



                            <div>
                                <motion.button
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.99 }}
                                    transition={{ duration: 0.2 }} className="font-bold text-xs sm:text-sm lg:text-base">

                                    {postData.postType.toLowerCase() === "buynow"
                                        ? <NavLink to="/discover" className="px-4 py-2 lg:px-6 lg:py-2.5 
                                        bg-[#d8d8d8] dark:bg-[#5755a3] text-l-LightBlack dark:text-white rounded-md lg:rounded-lg">Buy Now</NavLink>

                                        : postData.postType.toLowerCase() === "stakenow"
                                            ? <NavLink to="/nftStaking" className="px-4 py-2 lg:px-6 lg:py-2.5 
                                            bg-[#d8d8d8] dark:bg-[#5755a3] text-l-LightBlack dark:text-white rounded-md lg:rounded-lg">Stake now</NavLink>

                                            : postData.postType.toLowerCase() === "mintnow"
                                                ? <NavLink to="/nftMint" className="px-4 py-2 lg:px-6 lg:py-2.5 
                                                bg-[#d8d8d8] dark:bg-[#5755a3] text-l-LightBlack dark:text-white rounded-md lg:rounded-lg">Mint now</NavLink>

                                                : postData.postType.toLowerCase() === "auction"
                                                && <NavLink to="/discover" className="px-4 py-2 lg:px-6 lg:py-2.5 
                                                bg-[#d8d8d8] dark:bg-[#5755a3] text-l-LightBlack dark:text-white rounded-md lg:rounded-lg">Auction</NavLink>
                                    }
                                </motion.button>
                            </div>
                        </div>
                    }

                    <div className="xs:mt-1 sm:mt-4 flex justify-between items-start xs:pl-1.5 sm:pl-6 xs:pb-4 sm:pb-5">

                        <div className="flex justify-start items-start flex-1 xs:mt-3 sm:mt-0">
                            <motion.button
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.99 }}
                                transition={{ duration: 0.2 }}
                                className="xs:w-8 xs:h-6 sm:w-12 sm:h-10 rounded-full">
                                <NavLink to="/profile/activity">
                                    <div>
                                        <img src={postData.profilePhoto} alt="" className="w-full h-full" />
                                    </div>
                                </NavLink>
                            </motion.button>


                            <div className="add_comment_box xs:p-1 sm:p-2 rounded-sm xs:ml-1.5 sm:ml-3 xs:mr-2 lg:mr-5 xl:mr-3 
                            w-full relative h-full">

                                <div className="flex">
                                    <textarea
                                        name=""
                                        id={`commentWriteBox${index}`}
                                        onChange={(e) => handleCommentSubmit(e, index, postData.id)}
                                        onKeyDown={(e) => handleCommentKeyboardEvent(e)}

                                        placeholder='Add comment'
                                        style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                                        className="text-cusBlack dark:text-white bg-transparent outline-none
                                    appearance-none w-full resize-none h-4 sm:h-6 max-h-[200px] overflow-auto xs:text-xxs sm:text-base"
                                    />
                                </div>



                                <div className="hidden md:flex justify-end pt-0 items-center space-x-4 bottom-2.5 right-3 absolute"
                                    id={`commentIconsBox${index}`}>


                                    <div className="flex justify-end items-center xs:space-x-4 sm:space-x-2 lg:space-x-4 xl:space-x-2 2xl:space-x-4">
                                        <button className="relative mt-0.5 m-0 p-0 h-fit w-fit"
                                            ref={(el) => emojiPikcerRefs.current[index] = el}>
                                            <div className="absolute bottom-7 left-0" id={`emojiPicker${index}`}>

                                            </div>
                                            <div id="" className="cursor-pointer mb-0" onClick={(e) => hanldeEmojiOpenBtn(index)} >
                                                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20">
                                                    <g id="Smile" transform="translate(0.349)">
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape" d="M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,1.22A8.806,8.806,0,1,0,16.2,3.8,8.79,8.79,0,0,0,10,1.22Z" transform="translate(-0.349)" fill="" />
                                                        <circle className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Oval" cx="0.976" cy="0.976" r="0.976" transform="translate(5.082 6.512)" fill="" />
                                                        <circle className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Oval-2" data-name="Oval" cx="0.976" cy="0.976" r="0.976" transform="translate(12.691 6.512)" fill="" />
                                                        <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape-2" data-name="Shape" d="M5.789,5.61A6.044,6.044,0,0,1,.032,1.317,1.078,1.078,0,0,1,.2.415,1.023,1.023,0,0,1,1.032,0h9.512a1.054,1.054,0,0,1,.8.415,1,1,0,0,1,.171.9A5.983,5.983,0,0,1,5.789,5.61Zm0-2.2a2.556,2.556,0,0,0-1.707.659,4.569,4.569,0,0,0,1.558.3q.075,0,.15,0A4.956,4.956,0,0,0,7.5,4.049,2.7,2.7,0,0,0,5.789,3.415Zm0-1.22a3.735,3.735,0,0,1,2.8,1.268,4.933,4.933,0,0,0,1.683-2.219H1.326A4.706,4.706,0,0,0,2.983,3.463,3.687,3.687,0,0,1,5.789,2.2Z" transform="translate(4.074 10.732)" fill="" />
                                                    </g>
                                                </svg>
                                            </div>
                                        </button>
                                        <button className="" onClick={() => setIsWebcamOpen({ isOpen: !isWebcamOpen.isOpen, index: index, postId: postData.id })}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.744" height="20.641" viewBox="0 0 22.744 20.641">
                                                <g id="Photo" transform="translate(0.5 0.5)">
                                                    <circle className="stroke-[#A6A6A7] dark:stroke-[#6f6dab]" id="Oval" cx="4.41" cy="4.41" r="4.41" transform="translate(6.462 6.41)" fill="none" stroke="" strokeMiterlimit={10} strokeWidth={1} />
                                                    <path className="stroke-[#A6A6A7] dark:stroke-[#6f6dab]" id="Shape" d="M18.436,19.641H3.307A3.311,3.311,0,0,1,0,16.333V6.026A3.311,3.311,0,0,1,3.307,2.718h1a1.856,1.856,0,0,0,1.334-.564L7,.743A2.3,2.3,0,0,1,8.718,0H12.9A2.334,2.334,0,0,1,14.59.718L16.025,2.18a1.89,1.89,0,0,0,1.308.538h1.1a3.312,3.312,0,0,1,3.308,3.308V16.333A3.312,3.312,0,0,1,18.436,19.641Zm-7.564-14.9a6.077,6.077,0,1,0,6.077,6.077A6.084,6.084,0,0,0,10.872,4.744ZM18.23,4.8a1.256,1.256,0,1,0,1.256,1.256A1.258,1.258,0,0,0,18.23,4.8Z" transform="translate(0 0)" fill="none" stroke="" strokeMiterlimit={10} strokeWidth={1} />
                                                </g>
                                            </svg>
                                        </button>
                                        <div className="relative"
                                            ref={(el) => gifBoxsRefs.current[index] = el}>
                                            <div id={`gifBox${index}`}
                                                className="hidden bottom-7 left-0 w-72 h-[400px]">
                                                <GIFs handleGifOnClick={handleGifOnClick} />
                                            </div>
                                            <div id="" className="cursor-pointer mb-0" onClick={() => hanldeGIFBoxOpenBtn(index, postData.id)}>
                                                <svg id="GIF" xmlns="http://www.w3.org/2000/svg" width="20.697" height="19.697" viewBox="0 0 20.697 19.697">
                                                    <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape" d="M14.233,19.7H6.465A6.472,6.472,0,0,1,0,13.233V6.465A6.472,6.472,0,0,1,6.465,0h7.768A6.472,6.472,0,0,1,20.7,6.465v6.768A6.472,6.472,0,0,1,14.233,19.7ZM6.465,1.163a5.308,5.308,0,0,0-5.3,5.3v6.791a5.308,5.308,0,0,0,5.3,5.3h7.768a5.308,5.308,0,0,0,5.3-5.3V6.465a5.308,5.308,0,0,0-5.3-5.3Z" transform="translate(0)" fill="" />
                                                    <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path" d="M.581,0A.576.576,0,0,0,0,.581V8.3a.576.576,0,0,0,.581.581A.576.576,0,0,0,1.163,8.3V.581A.576.576,0,0,0,.581,0Z" transform="translate(11 5.651)" fill="" />
                                                    <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path-2" data-name="Path" d="M.581,0A.576.576,0,0,0,0,.581V8.3a.576.576,0,0,0,.581.581A.576.576,0,0,0,1.163,8.3V4.791H4.07a.581.581,0,0,0,0-1.163H1.163V1.163H4.07A.576.576,0,0,0,4.651.581.576.576,0,0,0,4.07,0Z" transform="translate(13.512 5.651)" fill="" />
                                                    <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path-3" data-name="Path" d="M3.814,1.163A2.483,2.483,0,0,1,5.791,2.256a.581.581,0,0,0,.93-.7A3.593,3.593,0,0,0,3.814,0C1.7,0,0,2,0,4.442S1.721,8.884,3.814,8.884A3.593,3.593,0,0,0,6.721,7.326a.571.571,0,0,0,.116-.349v-2.3a.581.581,0,0,0-1.163,0V6.767a2.39,2.39,0,0,1-1.86.93c-1.465,0-2.651-1.465-2.651-3.279S2.349,1.163,3.814,1.163Z" transform="translate(3 5.651)" fill="" />
                                                </svg>
                                            </div>
                                        </div>
                                        <button {...getRootProps({ className: 'uploadImageToPost' })}>
                                            <input  {...getInputProps()} type="file" name="" id="" />
                                            <div onClick={() => setClickedPhUpIndex(index)} >
                                                <svg id="File" xmlns="http://www.w3.org/2000/svg" width="21.25" height="19.595" viewBox="0 0 21.25 19.595">
                                                    <circle className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Oval" cx="1.357" cy="1.357" r="1.357" transform="translate(9.054 3.595)" fill="" />
                                                    <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Shape" d="M12.221,19.595H12.03l-9.619-.666a2.567,2.567,0,0,1-2.4-2.762L.959,2.4A2.638,2.638,0,0,1,3.554,0h.191L13.34.69A2.6,2.6,0,0,1,15.768,3.4l-.547,7.762-.428,6a2.569,2.569,0,0,1-.881,1.786A2.487,2.487,0,0,1,12.221,19.595Zm-8.1-9.214-2.69,2.167-.262,3.69a1.412,1.412,0,0,0,1.309,1.5l9.618.667h.1a1.433,1.433,0,0,0,.929-.334,1.331,1.331,0,0,0,.476-.952l.428-5.738-2.857-3.31-4.31,3.6.619.69a.581.581,0,0,1,.146.426.59.59,0,0,1-.194.408.649.649,0,0,1-.405.143.556.556,0,0,1-.452-.191Zm-.548-9.19A1.407,1.407,0,0,0,2.174,2.5l-.6,8.452L3.864,9.119a.586.586,0,0,1,.365-.127.6.6,0,0,1,.445.2l1.382,1.571L10.84,6.786a.59.59,0,0,1,.377-.137.617.617,0,0,1,.457.208L14.15,9.69,14.6,3.357a1.412,1.412,0,0,0-1.31-1.5L3.673,1.191Z" transform="translate(5.476)" fill="" />
                                                    <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path" d="M2.483,1.452l2.667-.214A3.888,3.888,0,0,1,5.816,0L2.387.286a2.556,2.556,0,0,0-1.762.9A2.579,2.579,0,0,0,.007,3.071L1.1,16.81a2.556,2.556,0,0,0,.9,1.762,2.582,2.582,0,0,0,1.667.619h.214L5.1,19.1l-.143-.143a4.931,4.931,0,0,1-.643-.976l-.548.048a1.428,1.428,0,0,1-1.524-1.286L1.149,3A1.462,1.462,0,0,1,2.483,1.452Z" transform="translate(0 0.095)" fill="" />
                                                </svg>
                                            </div>
                                        </button>
                                        <button onClick={() => setIsRecorderOpen({ isOpen: !isRecorderOpen.isOpen, index: index, postId: postData.id })}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13.535" height={21} viewBox="0 0 13.535 21">
                                                <g id="mic" transform="translate(-91)">
                                                    <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path_1030" data-name="Path 1030" d="M104.535,255H103.3a5.537,5.537,0,0,1-11.074,0H91a6.777,6.777,0,0,0,6.152,6.739v2.571H92.846v1.23h9.844v-1.23H98.383v-2.571A6.777,6.777,0,0,0,104.535,255Z" transform="translate(0 -244.541)" fill="" />
                                                    <path className="fill-[#A6A6A7] dark:fill-[#6f6dab]" id="Path_1031" data-name="Path 1031" d="M155.307,14.766a4.312,4.312,0,0,0,4.307-4.307V4.307a4.307,4.307,0,0,0-8.613,0v6.152A4.312,4.312,0,0,0,155.307,14.766Zm0-13.535a3.081,3.081,0,0,1,3.014,2.461h-1.784v1.23h1.846V6.768h-1.846V8h1.846V9.844h-1.846v1.23h1.784a3.076,3.076,0,0,1-6.029,0h1.784V9.844H152.23V8h1.846V6.768H152.23V4.922h1.846V3.691h-1.784A3.081,3.081,0,0,1,155.307,1.23Z" transform="translate(-57.539)" fill="" />
                                                </g>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mr-4 xs:mt-3 sm:mt-0.5 flex xs:space-x-1.5 sm:space-x-2 lg:space-x-4 xl:space-x-2 2xl:space-x-4 ">
                            <div className="flex items-center">
                                <button className={`love_btn_box ${postData.isMyloves ? 'active' : ''}`}
                                    onClick={() => handleLoveBtnClick(postData.id)}>
                                    <div className="cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-5 sm:w-8 " fill="none" viewBox="0 0 24 24" stroke="#e62ccf" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                        </svg>
                                    </div>
                                </button>
                                <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusGray xs:ml-0.5 sm:ml-1">{abbreviateNumber(postData.loves)}</p>
                            </div>

                            <div className="flex items-center">
                                <button onClick={() => setCommentsShow({ isOpen: (!commentsShow.isOpen), index: index })}>
                                    <svg id="Group_16" className="xs:w-4 sm:w-8 " data-name="Group 16" xmlns="http://www.w3.org/2000/svg" width="23.317" height="22.76" viewBox="0 0 23.317 22.76">
                                        <g id="Group_15" data-name="Group 15">
                                            <path id="Path_3" data-name="Path 3" d="M11.659,0C5.2,0,0,4.581,0,10.22a9.875,9.875,0,0,0,4.323,7.988l.182,3.82c.034.712.524.944,1.094.52L8.744,20.2a11.793,11.793,0,0,0,2.915.294c6.461,0,11.659-4.581,11.659-10.22S18.12,0,11.659,0Z" fill="#6f6dab" />
                                        </g>
                                    </svg>
                                </button>
                                <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusGray xs:ml-0.5 sm:ml-1">{postData.comments.length}</p>
                            </div>

                            <div className="flex items-center">
                                <button onClick={() => setShareModalOpen(!shareModalOpen)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-4 sm:w-8 " width="27.743" height="22.397" viewBox="0 0 27.743 22.397">
                                        <g id="_09" data-name="09" transform="translate(0 0)">
                                            <g id="Слой_2" data-name="Слой 2" transform="translate(0)">
                                                <g id="Слой_1" data-name="Слой 1">
                                                    <path id="Path_5" data-name="Path 5" d="M0,21.625a.872.872,0,0,0,.688.771.872.872,0,0,0,.989-.6A14.557,14.557,0,0,1,5.6,16.761a14.842,14.842,0,0,1,9.308-3.354h3.539v3.069a.738.738,0,0,0,.235.52.721.721,0,0,0,.47.184.688.688,0,0,0,.47-.184L27.538,9.08a.7.7,0,0,0,0-.989L19.639.209A.7.7,0,0,0,18.449.7V3.764H17.023A17.24,17.24,0,0,0,3.607,10.472,18.079,18.079,0,0,0,0,21.625Z" transform="translate(0.002 -0.014)" fill="#6f6dab" />
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                                <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusGray xs:ml-0.5 sm:ml-1">{postData.shares}</p>
                            </div>
                        </div>
                    </div>


                    {/* Photo, Voice Record, Gig Preview section */}
                    <div className="flex justify-between items-start xs:pl-1.5 sm:pl-6">
                        <div className="flex justify-start items-start">
                            <div className="ml-2 sm:ml-3 flex flex-wrap w-full" id={`assetsPreviewUnderComment${index}`}>

                            </div>
                        </div>
                    </div>


                    <div className={`${postData.comments.length > 0 ? 'h-56 px-6 py-3' : ''} overflow-auto comments_box hidden`} id={`comments_box_${index}`}>
                        {postData?.comments.map((comm: any) =>
                            <motion.div
                                initial="hidden"
                                animate="visible"
                                variants={{
                                    hidden: { x: -100 },
                                    visible: { x: 0 },
                                }}

                                transition={{ duration: 0.5 }}
                                className="flex justify-start items-start mb-4" key={comm.id}>
                                <NavLink to="/publicProfile/activity">
                                    <div className="xs:w-8 sm:w-10 xs:h-8 sm:h-10 rounded-full">
                                        <img src={comm.profLogo} alt="" className="xs:w-8 sm:w-10 xs:h-8 sm:h-10 " />
                                    </div>
                                </NavLink>

                                <div className="ml-5 text-left flex-1">
                                    {comm.commTitle &&
                                        <p className="xs:text-xs sm:text-sm xl:text-base pt-1.5 sm:py-1.5 text-cusBlack dark:text-white break-all"
                                            style={{ whiteSpace: 'pre-line', }}>{comm.commTitle}</p>
                                    }
                                    {comm.commPhoto &&
                                        <div className={`w-20 sm:w-36 h-auto rounded-md mt-0.5 overflow-hidden hover:opacity-60 cursor-pointer`}>
                                            <img src={comm.commPhoto} className="w-full h-full" alt="" />
                                        </div>
                                    }
                                    {comm.commAudio &&
                                        comm.commAudio.length > 0 &&
                                        <AudioPlayer audioPlyrProps={setAudioPlayer(comm.commAudio)} />
                                    }
                                    <TimeAgo
                                        className="text-cusBlack dark:text-cusBlueWhite text-xxs sm:text-xs"
                                        datetime={comm.time}
                                        locale='en_US'
                                    />
                                </div>
                            </motion.div>
                        )}
                    </div>

                </motion.div >
            )}



            {/* Voice Recorder Modal */}
            <AnimatePresence>
                {isRecorderOpen.isOpen &&
                    <div
                        className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={isRecorderOpen.isOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={recorderModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757] rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle
                                    sm:max-w-md lg:max-w-xl sm:w-full">
                                <div className="text-right pr-6 pt-5">
                                    <button onClick={() => setIsRecorderOpen({ isOpen: false, index: -1, postId: -1 })}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>

                                <div className="px-4 pt-1 pb-10 text-center">
                                    <VoiceRecorder hanldeVoiceSubmit={hanldeVoiceSubmit} />
                                </div>
                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>


            {/* WebCam Modal */} <AnimatePresence>
                {isWebcamOpen.isOpen &&
                    <div
                        className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 bg-gray-900 transition-all bg-opacity-75" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={isWebcamOpen.isOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0, x: -100 }}
                                transition={{ duration: 0.1 }}
                                ref={webCamModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757] rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle
                                    sm:max-w-md lg:max-w-xl sm:w-full">
                                <div className="text-right pr-6 pt-5">
                                    <button onClick={() => setIsWebcamOpen({ isOpen: false, index: -1, postId: -1 })}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>

                                <div className="px-4 pt-1 pb-10 text-center">
                                    {isSubmitted
                                        ? <div className="shadow w-full mt-6 mb-3 bg-gray-200 rounded-full overflow-hidden">
                                            <div className="gradientBtn text-xs leading-none py-1 text-center rounded-full transition-all text-white"
                                                style={{ width: `${uploadingPercentage}%` }}>{`${uploadingPercentage}%`}</div>
                                        </div>

                                        : <div className="mx-auto w-80 p-3 bg-cusGray dark:bg-[#292757] shadow-xl  dark:shadow-[#1e1c3c]">
                                            <WebCamCapture hanldeWebCamPhotoSubmit={hanldeWebCamPhotoSubmit} />
                                        </div>
                                    }
                                </div>
                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>


            {/* Share Modal */}
            <AnimatePresence>
                {/* {shareModalOpen &&
                    <div
                        className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={shareModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={shareModalRef} className="relative inline-block align-bottom bg-white dark:bg-[#292757] rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle
                                    sm:max-w-md lg:max-w-xl sm:w-full">
                                <div className="text-right pr-6 pt-5">
                                    <button onClick={() => setShareModalOpen(false)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>

                                <div className="px-0 pt-1 pb-10 text-center ">
                                    <h4 className="text-cusBlack dark:text-gray-100 xs:text-lg sm:text-2xl font-bold">Share This Post</h4>
                                    <p className="text-cusBlack dark:text-gray-300 mt-2 text-sm font-thin break-words px-3">Lorem ipsum dolor sit amet consectetur</p>

                                    <div className="xs:grid grid-cols-2 gap-x-3 gap-y-8 md:flex md:space-x-10 justify-center items-center mt-8 mx-2">
                                        <a href="#" className="">
                                            <svg xmlns="http://www.w3.org/2000/svg" data-name="Ebene 1" className="xs:w-9 md:w-12 mx-auto" viewBox="0 0 1024 1024">
                                                <path fill="#1877f2" d="M1024,512C1024,229.23016,794.76978,0,512,0S0,229.23016,0,512c0,255.554,187.231,467.37012,432,505.77777V660H302V512H432V399.2C432,270.87982,508.43854,200,625.38922,200,681.40765,200,740,210,740,210V336H675.43713C611.83508,336,592,375.46667,592,415.95728V512H734L711.3,660H592v357.77777C836.769,979.37012,1024,767.554,1024,512Z" />
                                                <path fill="#fff" d="M711.3,660,734,512H592V415.95728C592,375.46667,611.83508,336,675.43713,336H740V210s-58.59235-10-114.61078-10C508.43854,200,432,270.87982,432,399.2V512H302V660H432v357.77777a517.39619,517.39619,0,0,0,160,0V660Z" />
                                            </svg>
                                            <p className="text-cusBlack dark:text-white mt-2 text-xs text-center">Facebook</p>
                                        </a>

                                        <a href="#" className="">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-9 md:w-12 mx-auto" viewBox="0 0 512 512">
                                                <switch>
                                                    <g>
                                                        <path fill="#0A7BBA" d="M506 256.879c0 138.066-111.934 250-250 250-138.067 0-250-111.934-250-250 0-138.067 111.933-250 250-250 138.066 0 250 111.933 250 250zm0 0" />
                                                        <path fill="#F2F2F2" d="M405.36 276.985v103.076h-59.753v-96.157c0-24.153-8.617-40.647-30.269-40.647-16.493 0-26.308 11.119-30.638 21.869-1.588 3.83-1.98 9.161-1.98 14.558v100.378h-59.774s.805-162.873 0-179.734h59.774v25.478c-.108.196-.282.389-.392.585h.392v-.585c7.943-12.227 22.108-29.702 53.856-29.702 39.321 0 68.784 25.698 68.784 80.881zM160.452 113.698c-20.455 0-33.815 13.426-33.815 31.052 0 17.255 12.969 31.049 33.032 31.049h.37c20.846 0 33.815-13.793 33.815-31.049-.392-17.625-12.969-31.052-33.402-31.052zm-30.268 266.364h59.731V200.328h-59.731v179.734zm0 0" />
                                                    </g>
                                                </switch>
                                            </svg>
                                            <p className="text-cusBlack dark:text-white mt-2 text-xs text-center">Linkedin</p>
                                        </a>
                                        <a href="#" className="">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="xs:w-9 md:w-12 mx-auto">
                                                <path fill="#03A9F4" d="M16 3.539a6.839 6.839 0 0 1-1.89.518 3.262 3.262 0 0 0 1.443-1.813 6.555 6.555 0 0 1-2.08.794 3.28 3.28 0 0 0-5.674 2.243c0 .26.022.51.076.748a9.284 9.284 0 0 1-6.761-3.431 3.285 3.285 0 0 0 1.008 4.384A3.24 3.24 0 0 1 .64 6.578v.036a3.295 3.295 0 0 0 2.628 3.223 3.274 3.274 0 0 1-.86.108 2.9 2.9 0 0 1-.621-.056 3.311 3.311 0 0 0 3.065 2.285 6.59 6.59 0 0 1-4.067 1.399c-.269 0-.527-.012-.785-.045A9.234 9.234 0 0 0 5.032 15c6.036 0 9.336-5 9.336-9.334 0-.145-.005-.285-.012-.424A6.544 6.544 0 0 0 16 3.539z" />
                                            </svg>
                                            <p className="text-cusBlack dark:text-white mt-2 text-xs text-center">Twitter</p>
                                        </a>

                                        <a href="#" className="">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-9 md:w-12 mx-auto" fill="none" viewBox="0 0 48 48">
                                                <rect width={48} height={48} fill="#0DC143" rx={24} />
                                                <path fill="#fff" d="M34.7507 13.2115C32.1777 10.5628 28.621 9.125 24.9885 9.125C17.2696 9.125 11.0642 15.4061 11.1399 23.0493C11.1399 25.4709 11.821 27.8169 12.9561 29.9358L10.9885 37.125L18.3291 35.2331C20.3723 36.3682 22.6426 36.898 24.9128 36.898C32.5561 36.898 38.7615 30.6169 38.7615 22.9736C38.7615 19.2655 37.3237 15.7845 34.7507 13.2115ZM24.9885 34.552C22.9453 34.552 20.902 34.0223 19.1615 32.9628L18.7074 32.7358L14.3183 33.8709L15.4534 29.5574L15.1507 29.1034C11.821 23.7304 13.4101 16.6169 18.8588 13.2872C24.3074 9.95743 31.3453 11.5466 34.675 16.9953C38.0047 22.4439 36.4156 29.4818 30.9669 32.8115C29.2264 33.9466 27.1074 34.552 24.9885 34.552ZM31.648 26.152L30.8156 25.7736C30.8156 25.7736 29.6047 25.2439 28.848 24.8655C28.7723 24.8655 28.6966 24.7899 28.621 24.7899C28.3939 24.7899 28.2426 24.8655 28.0912 24.9412C28.0912 24.9412 28.0156 25.0169 26.9561 26.2277C26.8804 26.3791 26.7291 26.4547 26.5777 26.4547H26.502C26.4264 26.4547 26.275 26.3791 26.1993 26.3034L25.821 26.152C24.9885 25.7736 24.2318 25.3196 23.6264 24.7142C23.475 24.5628 23.248 24.4115 23.0966 24.2601C22.5669 23.7304 22.0372 23.125 21.6588 22.4439L21.5831 22.2926C21.5074 22.2169 21.5074 22.1412 21.4318 21.9899C21.4318 21.8385 21.4318 21.6872 21.5074 21.6115C21.5074 21.6115 21.8101 21.2331 22.0372 21.0061C22.1885 20.8547 22.2642 20.6277 22.4156 20.4764C22.5669 20.2493 22.6426 19.9466 22.5669 19.7196C22.4912 19.3412 21.5831 17.298 21.3561 16.8439C21.2047 16.6169 21.0534 16.5412 20.8264 16.4655H20.5993C20.448 16.4655 20.221 16.4655 19.9939 16.4655C19.8426 16.4655 19.6912 16.5412 19.5399 16.5412L19.4642 16.6169C19.3128 16.6926 19.1615 16.8439 19.0101 16.9196C18.8588 17.0709 18.7831 17.2223 18.6318 17.3736C18.102 18.0547 17.7993 18.8872 17.7993 19.7196C17.7993 20.325 17.9507 20.9304 18.1777 21.4601L18.2534 21.6872C18.9345 23.125 19.8426 24.4115 21.0534 25.5466L21.3561 25.8493C21.5831 26.0764 21.8101 26.2277 21.9615 26.4547C23.5507 27.8169 25.3669 28.8007 27.4101 29.3304C27.6372 29.4061 27.9399 29.4061 28.1669 29.4818C28.3939 29.4818 28.6966 29.4818 28.9237 29.4818C29.302 29.4818 29.7561 29.3304 30.0588 29.1791C30.2858 29.0277 30.4372 29.0277 30.5885 28.8764L30.7399 28.725C30.8912 28.5736 31.0426 28.498 31.1939 28.3466C31.3453 28.1953 31.4966 28.0439 31.5723 27.8926C31.7237 27.5899 31.7993 27.2115 31.875 26.8331C31.875 26.6818 31.875 26.4547 31.875 26.3034C31.875 26.3034 31.7993 26.2277 31.648 26.152Z" />
                                            </svg>
                                            <p className="text-cusBlack dark:text-white mt-2 text-xs text-center">WhatsApp</p>
                                        </a>
                                    </div>




                                </div>
                            </motion.div>
                        </div>
                    </div>
                } */}
            </AnimatePresence>



            {/* Post Share Modal */}
            <AnimatePresence>
                {shareModalOpen &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={shareModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={shareModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                                    rounded-2xl text-left overflow-hidden transform transition-all sm:align-middle
                                                 w-11/12 xsm:max-w-sm md:max-w-sm xl:max-w-md xsm:w-full">

                                <div className="flex justify-between items-center px-6 pt-5">
                                    <h5 className="text-cusBlack dark:text-white text-xl font-extrabold dark:font-bold">Share</h5>

                                    <button onClick={() => setShareModalOpen(false)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>
                                <div className="border-b border-[#dedede] dark:border-[#473a94] mt-2"></div>

                                <div className="px-6 py-3 flex justify-start items-center">
                                    <p className="text-cusBlack dark:text-white font-bold">To:</p>
                                    <input type="text" name="" id=""
                                        onChange={handleShareModalSearch}
                                        placeholder="Search..."
                                        className="bg-transparent outline-none w-full ml-2 text-cusBlack dark:text-white"
                                    />
                                </div>

                                <div className="border-b border-[#dedede] dark:border-[#473a94] "></div>

                                <div className="pl-6 pt-3">
                                    <p className="text-cusBlack dark:text-white font-bold text-sm">Suggested</p>

                                    <div className="flex flex-col pb-2 h-[200px] sm:h-[300px] xl:h-[320px] overflow-auto mt-2">
                                        {modalPeoplesData.map((people, index) =>
                                            <label htmlFor={`shareToPeople${index}`} key={people.id}>
                                                <div className="flex justify-between items-center 
                                                hover:bg-[#00000010] dark:hover:bg-[#00000020] pl-3 py-[7px] pr-7 rounded-l-lg">
                                                    <div className="flex justify-start items-center">
                                                        <div className="
                                                        w-[40px] h-[40px]
                                                        md:w-[50px] md:h-[50px] rounded-full overflow-hidden">
                                                            <div>
                                                                <img src={people.photo} alt="" className="w-full h-full" />
                                                            </div>
                                                        </div>
                                                        <div className="text-left ml-3">
                                                            <h5 className="text-cusBlack dark:text-white text-sm lg:text-base
                                                            max-w-[100px] xxsm:max-w-[120px] sm:max-w-[160px] truncate">{people.name}</h5>
                                                        </div>
                                                    </div>

                                                    <div className="">
                                                        <input type="checkbox"
                                                            name="shareToPeopleCheckbox" id={`shareToPeople${index}`}
                                                            className="bg-transparent cursor-pointer border-2 dark:border-[#ff0091]
                                                            dark:checked:bg-[#ff0091] checked:bg-[#2563eb] dark:focus:outline-pink-600
                                                            w-4 h-4 md:w-5 md:h-5 focus:outline-none rounded-full form-checkbox transition-all" />
                                                    </div>
                                                </div>

                                            </label>
                                        )}
                                    </div>
                                </div>


                                <div className="px-6 py-3 xl:py-4">
                                    <button className="w-full py-2 gradientBG text-white font-bold rounded-md
                                     hover:tracking-wider transition-all duration-300">
                                        Send
                                    </button>

                                    <button className="w-full py-2 flex justify-center items-center mt-3 border-2 border-[#c5c5c5] dark:border-[#8481c5]
                                rounded-lg group
                                    ">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 md:w-6 stroke-l-LightBlack dark:stroke-cusBlueWhite" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
                                        </svg>

                                        <p className="text-l-LightBlack dark:text-cusBlueWhite ml-1 font-semibold 
                                        group-hover:tracking-wider transition-all duration-300 select-none text-sm md:text-base
                                        ">Copy Link</p>
                                    </button>
                                </div>

                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>



            {/* Report Modal */}
            <AnimatePresence>
                {reportModalOpen &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={reportModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={reportModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                                    rounded-2xl text-left transform transition-all sm:align-middle
                                                  max-w-sm xl:max-w-lg w-full">
                                <div className="px-6 py-5">
                                    <div className="flex justify-between items-center">
                                        <h5 className="text-cusBlack dark:text-white text-base xxsm:text-xl font-extrabold dark:font-bold">Report this Post</h5>

                                        <button onClick={() => setReportModalOpen(false)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.855" className="blackWhiteSVG2" height="14.856" viewBox="0 0 21.855 21.856">
                                                <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                                <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            </svg>
                                        </button>
                                    </div>

                                    <div className="my-8">
                                        <p className="text-cusBlack dark:text-white font-semibold inline-block cursor-default text-xs xxsm:text-sm xsm:text-base">I think this account is...</p>

                                        <div
                                            ref={reasonDropRef}
                                            className="border-2 border-[#e6e8ec] hover:border-gray-300 dark:hover:border-gray-400
                                            dark:border-[#e6e8ec20] px-3 py-3 rounded-md md:rounded-lg mt-1 transition-all cursor-pointer relative w-full text-left"
                                            onClick={() => setReasonDropOpen(!reasonDropOpen)}>
                                            <div className="flex justify-between items-center break-all">
                                                <h4 className="text-l-LightBlack dark:text-white font-semibold text-xs md:text-sm truncate">{reasonText}</h4>
                                                <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 blackWhiteSVG3 transition-all ${reasonDropOpen && 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                                </svg>
                                            </div>
                                            <AnimatePresence>
                                                {reasonDropOpen &&
                                                    <motion.div
                                                        animate={reasonDropOpen ? "open" : "closed"}
                                                        initial={{ y: -15, }}
                                                        variants={{
                                                            open: { y: 0, },
                                                            closed: { y: -100, },
                                                        }}
                                                        exit={{ opacity: 0, y: -15 }}
                                                        transition={{ duration: 0.2 }}
                                                        className="rounded-xl overflow-hidden absolute top-10 md:top-12 bg-white dark:bg-[#3b316e] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20">
                                                        {[
                                                            "Fake collection or possible scam",
                                                            "Explicit and sensitive content",
                                                            "Spam",
                                                            "Might be stolen",
                                                            "Harassment",
                                                            "False information",
                                                            "Unauthorized Sales",
                                                            "Hate Speech",
                                                            "Terrorism",
                                                            "Something Else",
                                                            "Other",
                                                        ].map(item =>
                                                            <div onClick={() => { setReasonText(item) }}
                                                                className="py-1.5 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all" key={item}>
                                                                <p className="text-cusBlack dark:text-white text-xs lg:text-sm font-normal truncate">{item}</p>
                                                            </div>
                                                        )}
                                                    </motion.div>}
                                            </AnimatePresence>
                                        </div>
                                    </div>


                                    <button
                                        onClick={() => setReportModalOpen(false)}
                                        className="gradientBtn w-full py-3 rounded-lg text-white font-semibold text-xs xxsm:text-sm xsm:text-base">
                                        Report Now
                                    </button>

                                </div>
                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>





            <AnimatePresence>
                {showEditModal.isOpen &&
                    <EditPost
                        setShowEditModal={setShowEditModal}
                        showEditModal={showEditModal}
                        editModalRef={editModalRef}
                    />
                }
            </AnimatePresence>


        </div>
    );
}

